import { render, staticRenderFns } from "./newCopyRight.vue?vue&type=template&id=5bd21fd3&scoped=true&"
import script from "./newCopyRight.vue?vue&type=script&lang=js&"
export * from "./newCopyRight.vue?vue&type=script&lang=js&"
import style0 from "./newCopyRight.vue?vue&type=style&index=0&id=5bd21fd3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd21fd3",
  null
  
)

export default component.exports